import { API_PATHS } from "../constants/api-paths";
import { type IResponse, encryptedRequest } from "../core/api.client";

export interface IMefAddOnProd {
  prodType: string;
  prodName: string;
  prodDescription: string;
  premium: string;
  coverage: string;
  tenure: string;
  nomineeName?: string;
  nomineeRel?: string;
  nomineeMob?: string;
  isSelected: boolean;
}
interface IMefInsertApiRequest {
  id?: string;
  mobileNo: string;
  journeyName: string; // icors or default
  journeyType?: string;
  eventCode: string;
  eventName: string;
  prodName: string;
  sourceUrl: string;
  custType: string;
  actualLoanAmt?: string;
  tenureInMon?: string;
  loanVariant?: string;
  initialTenor?: string;
  subsequentTenor?: string;
  roi?: string;
  hybridEmiAmt?: string;
  droplineEmiAmt?: string;
  emiAmt?: string;
  addOnProd?: IMefAddOnProd[];
  skuId?: string;
}

interface IMefInsertApiResponse {
  id: string;
  eventCode: string;
  journeyName: string;
}

export async function postMefInsertApi(
  requestBody: IMefInsertApiRequest
): Promise<IResponse<IMefInsertApiResponse>> {
  try {
    const response = await encryptedRequest<IMefInsertApiResponse, IMefInsertApiRequest>({
      method: "POST",
      url: API_PATHS.mefInsert,
      data: requestBody,
    });

    if (response.statusCode !== 90) {
      throw new Error(response.message);
    }

    return response;
  } catch (error) {
    console.error("Error in postMefInsertApi:", error);
    throw error;
  }
}
